import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { AlertTriangle } from "lucide-react";
import { B2bStatsCardProps } from "@/services/organizationsApi";

export function B2bAtRiskCard({ stats, loading, error }: B2bStatsCardProps) {
  const atRisk = stats?.business.at_risk_orgs ?? 0;
  const onboarding = stats?.seats.onboarding_incomplete ?? 0;
  const danger = atRisk > 0;
  return (
    <Card>
      <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
        <CardTitle className="text-sm font-medium">À risque</CardTitle>
        <AlertTriangle
          className={`h-4 w-4 ${danger ? "text-red-600" : "text-muted-foreground"}`}
        />
      </CardHeader>
      <CardContent>
        {loading && (
          <div className="text-sm text-muted-foreground">Chargement...</div>
        )}
        {error && <div className="text-sm text-red-600">{error}</div>}
        {!loading && !error && stats && (
          <>
            <div className={`text-2xl font-bold ${danger ? "text-red-600" : ""}`}>
              {atRisk}
            </div>
            <div className="mt-1 text-xs text-muted-foreground">
              impayé/dunning · {onboarding} onboarding incomplet
            </div>
          </>
        )}
      </CardContent>
    </Card>
  );
}
